export enum BlockingRequestStatusIds {
  "Создана" = 1,
  "Активна",
  "Неактивна",
  "Отменена",
  "Ошибка",
  "В обработке(Активация)",
  "В обработке(Деактивация)",
}
